import { defineMessages } from 'react-intl';

export default defineMessages({
  settings: {
    id: 'cboard.components.SettingsButton.settings',
    defaultMessage: 'Settings'
  }
});
